import i18n from '@/locales'
export const TYPES = [
  {
    key: 'local',
    label: i18n.t('system.text_541'),
  },
  {
    key: 'third',
    label: i18n.t('system.text_542'),
  },
]
